import { FragmentOf, graphql, ResultOf, TadaDocumentNode } from "gql.tada";

export const IndexWorkerProjectItemFragment = graphql(`
  fragment IndexWorkerProjectItem_project on IndexWorkerProject {
    id
    __typename
    name
    color
    indexWorkers {
      id
      __typename
      name
    }
  }
`);

export const SearchAnalyticsProjectItemFragment = graphql(`
  fragment SearchAnalyticsProjectItem_project on SearchAnalyticsProject {
    id
    __typename
    name
    color
    searchAnalytics {
      id
      __typename
      views {
        id
        name
      }
      bigQuery {
        id
        __typename
        latestDataDate
      }
    }
  }
`);

export const UserAnalyticsProjectItemFragment = graphql(`
  fragment UserAnalyticsProjectItem_project on UserAnalyticsProject {
    id
    __typename
    name
    color
    userAnalytics {
      id
      __typename
      bigQuery {
        id
        __typename
        latestDataDate
      }
      views {
        id
        name
      }
    }
  }
`);

export const AdsAnalyticsProjectItemFragment = graphql(`
  fragment AdsAnalyticsProjectItem_project on AdsAnalyticsProject {
    id
    __typename
    name
    color
    adsAnalytics {
      id
      __typename
      latestDataDate
      views {
        id
        name
      }
    }
  }
`);

// Organizationが持つProjectの配列に対するFragment
// 各Projectの具体的な型に応じて、上記で定義したFragmentを展開する
export const OrganizationProjectsFragment = graphql(
  `
    fragment OrganizationProjects_organization on Organization {
      id
      __typename
      enabledFeatures
      projectOrderIW
      projectOrderSA
      projectOrderUA
      projectOrderAA
      projects {
        id
        __typename
        name
        ... on IndexWorkerProject {
          id
          ...IndexWorkerProjectItem_project
        }
        ... on SearchAnalyticsProject {
          id
          ...SearchAnalyticsProjectItem_project
        }
        ... on UserAnalyticsProject {
          id
          ...UserAnalyticsProjectItem_project
        }
        ... on AdsAnalyticsProject {
          ...AdsAnalyticsProjectItem_project
        }
      }
    }
  `,
  [
    IndexWorkerProjectItemFragment,
    SearchAnalyticsProjectItemFragment,
    UserAnalyticsProjectItemFragment,
    AdsAnalyticsProjectItemFragment,
  ],
);

type ProjectFromOrg = NonNullable<
  ResultOf<typeof OrganizationProjectsFragment>
>["projects"][number];

export function filterProjectsByType<
  // biome-ignore lint/suspicious/noExplicitAny: anyでごまかす
  TFragmentDoc extends TadaDocumentNode<any, any, any>,
>(
  allProjects: readonly ProjectFromOrg[],
  typename: ProjectFromOrg["__typename"],
): FragmentOf<TFragmentDoc>[] {
  return allProjects.filter(
    (
      project,
    ): project is Extract<ProjectFromOrg, { __typename: typeof typename }> =>
      project.__typename === typename,
  ) as FragmentOf<TFragmentDoc>[];
}
